import React from 'react';
import map from 'lodash/map';
import merge from 'lodash/merge';
import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
// imports from consuming app
import { buildImagePath } from 'config/paths';

const defaultLink = 'https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto:eco,f_auto,fl_progressive:steep';
const cloudinaryLink = 'https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto,f_auto,fl_progressive:steep';

export class ListingImage extends React.Component {
  constructor (props) {
    super(props);

    this.imageHasLoaded = this.imageHasLoaded.bind(this);
    this.checkImg = this.checkImg.bind(this);
    this.srcSet = this.srcSet.bind(this);
    this.renderImgUrl = this.renderImgUrl.bind(this);
  }

  imageHasLoaded () {
    this.props.onPicLoad();
  }

  checkImg () {
    const { alt, defaultWidth, defaultHeight, imgId, sizes, style, id, onPicLoad } = this.props;
    const imgs = this.srcSet(imgId);
    const picLoadCB = function picLoadCB () {
      this.imageHasLoaded();
    }.bind(this);

    let extraSettings = {
      className: style,
      sizes,
      src: imgId ? `${defaultLink},w_${defaultWidth.toFixed(0)},h_${defaultHeight.toFixed(0)}/${imgId}` : buildImagePath('listing-placeholder.svg?v=rb'),
      itemProp: 'image',
      id: id
    };

    if (isFunction(onPicLoad)) {
      merge(extraSettings, { onLoad: picLoadCB });
    }

    return <img alt={ alt } srcSet={ imgs } { ...extraSettings } />
  }

  srcSet (id) {
    const { height, widths, addTransform } = this.props;
    const srcSetArray = map(widths, (width) => {
      let calcHeight = height ? height : (width / this.props.ratio);
      calcHeight = calcHeight.toFixed(0);
      return `${this.renderImgUrl(id, width, calcHeight, addTransform)} ${width}w`;
    });
    return srcSetArray.toString();
  }

  renderImgUrl (imgId, width, height, addTransform) {
    const dpr = this.props.dpr;
    const img = imgId ? `${cloudinaryLink},dpr_${ dpr || 2.0},w_${width},h_${height}/${addTransform ? addTransform : ''}${imgId}` : buildImagePath('listing-placeholder.svg?v=rb');
    return img;
  }

  render () {
    return (
      <div className={this.props.containerStyle || ''}>
        {this.checkImg()}
      </div>
    );
  }

}

ListingImage.propTypes = {
  alt: PropTypes.string,
  imgId: PropTypes.string.isRequired,
  ratio: PropTypes.number,
  defaultWidth: PropTypes.number.isRequired,
  defaultHeight: PropTypes.number.isRequired,
  widths: PropTypes.array.isRequired,
  height: PropTypes.number,
  style: PropTypes.string,
  sizes: PropTypes.string,
  containerStyle: PropTypes.string,
  id: PropTypes.string,
  onPicLoad: PropTypes.object
}
